import "./column-components.c66242f5.js";
import "./column-components.b2a20dc1.js";
import {format as $iVDzM$format} from "d3-format";
import {useContext as $iVDzM$useContext, createRef as $iVDzM$createRef, Component as $iVDzM$Component} from "react";
import {Popover as $iVDzM$Popover, Position as $iVDzM$Position, Button as $iVDzM$Button, Intent as $iVDzM$Intent} from "@blueprintjs/core";
import $iVDzM$chromajs from "chroma-js";
import $iVDzM$uibox from "ui-box";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $93d6aa7da8db25fe$exports = {};

$parcel$export($93d6aa7da8db25fe$exports, "DivisionEditOverlay", () => $93d6aa7da8db25fe$export$76fcb8530f09ae2e);



var $4bJ9d = parcelRequire("4bJ9d");


var $aVUB5 = parcelRequire("aVUB5");


const $93d6aa7da8db25fe$var$fmt = (0, $iVDzM$format)(".1f");
const $93d6aa7da8db25fe$var$fmt2 = (0, $iVDzM$format)(".2f");
const $93d6aa7da8db25fe$var$IntervalNotification = function(props) {
    const { id: id, height: height, bottom: bottom, top: top, surface: surface } = props;
    return (0, $4bJ9d.default)("div", [
        (0, $4bJ9d.default)("h4", `Section ${id} @ ${$93d6aa7da8db25fe$var$fmt(height)} m`),
        (0, $4bJ9d.default)("p", [
            "Interval ID: ",
            (0, $4bJ9d.default)("code", id)
        ]),
        (0, $4bJ9d.default)("p", `${bottom} - ${top} m`),
        surface ? (0, $4bJ9d.default)("p", [
            "Surface: ",
            (0, $4bJ9d.default)("code", surface)
        ]) : null
    ]);
};
const $93d6aa7da8db25fe$var$PopoverEditorTitle = function(props) {
    const { interval: interval, children: children } = props;
    return (0, $4bJ9d.default)("div.interval-editor-title", [
        (0, $4bJ9d.default)("h3", `${$93d6aa7da8db25fe$var$fmt2(interval.bottom)}\u{2013}${$93d6aa7da8db25fe$var$fmt2(interval.top)} m`),
        (0, $4bJ9d.default)("div.id", [
            (0, $4bJ9d.default)("code", interval.id)
        ]),
        children
    ]);
};
const $93d6aa7da8db25fe$var$OverlayBox = (props)=>{
    const { division: division, background: background, className: className, onClick: onClick } = props;
    const { widthForDivision: widthForDivision, scaleClamped: scaleClamped } = (0, $iVDzM$useContext)((0, $aVUB5.ColumnLayoutContext));
    if (scaleClamped == null) return null;
    const top = scaleClamped(division.top);
    const bottom = scaleClamped(division.bottom);
    const height = bottom - top;
    const width = widthForDivision(division);
    const style = {
        marginTop: top,
        height: height,
        width: width,
        pointerEvents: "none",
        position: "absolute"
    };
    return (0, $4bJ9d.default)("div", {
        style: style
    }, [
        (0, $4bJ9d.default)("div", {
            onClick: onClick,
            className: className,
            style: {
                cursor: onClick != null ? "pointer" : null,
                width: "100%",
                height: "100%",
                background: background
            }
        }),
        props.children
    ]);
};
const $93d6aa7da8db25fe$var$EditingBox = function({ division: division, color: color, ...rest }) {
    if (division == null) return null;
    if (color == null) color = "red";
    const background = (0, $iVDzM$chromajs)(color).alpha(0.5).css();
    return (0, $4bJ9d.default)($93d6aa7da8db25fe$var$OverlayBox, {
        className: "editing-box",
        division: division,
        background: background,
        ...rest
    });
};
class $93d6aa7da8db25fe$export$76fcb8530f09ae2e extends (0, $iVDzM$Component) {
    static #_ = this.contextType = (0, $aVUB5.ColumnLayoutContext);
    static #_2 = this.defaultProps = {
        onHoverInterval () {},
        onClick () {},
        left: 0,
        top: 0,
        showInfoBox: false,
        allowEditing: true,
        renderEditorPopup () {
            return null;
        },
        color: "red",
        popoverWidth: 340
    };
    constructor(props){
        super(props);
        this.onHoverInterval = this.onHoverInterval.bind(this);
        this.removeHoverBox = this.removeHoverBox.bind(this);
        this.heightForEvent = this.heightForEvent.bind(this);
        this.onEditInterval = this.onEditInterval.bind(this);
        this.onClick = this.onClick.bind(this);
        this.renderCursorLine = this.renderCursorLine.bind(this);
        this.renderHoveredBox = this.renderHoveredBox.bind(this);
        this.closePopover = this.closePopover.bind(this);
        this.state = {
            height: null,
            hoveredDivision: null,
            popoverIsOpen: false
        };
        this.timeout = null;
        this.elementRef = (0, $iVDzM$createRef)();
    }
    onHoverInterval(event) {
        event.stopPropagation();
        // findDOMNode might be slow but I'm not sure
        if (this.elementRef.current !== event.target) return;
        const height = this.heightForEvent(event);
        this.setState({
            height: height
        });
        if (!this.props.allowEditing) return;
        const { divisions: divisions } = this.context;
        let division = null;
        for (let d of Array.from(divisions))if (d.bottom <= height && height < d.top) {
            division = d;
            break;
        }
        if (division === this.state.hoveredDivision) return;
        this.setState({
            hoveredDivision: division
        });
        if (this.timeout != null) {
            clearTimeout(this.timeout);
            return this.timeout = null;
        }
    }
    removeHoverBox() {
        this.setState({
            hoveredDivision: null,
            popoverIsOpen: false
        });
        return this.timeout = null;
    }
    heightForEvent(event) {
        const { scale: scale } = this.context;
        const { offsetY: offsetY } = event.nativeEvent;
        return scale.invert(offsetY);
    }
    onEditInterval(event) {
        if (this.state.popoverIsOpen) return;
        // This could be moved to the actual interval
        // wrapped with a withRouter
        const { showInfoBox: showInfoBox } = this.props;
        const { hoveredDivision: hoveredDivision } = this.state;
        const height = this.heightForEvent(event);
        event.stopPropagation();
        if (event.shiftKey && showInfoBox) {
            this.setState({
                popoverIsOpen: true
            });
            return;
        }
        return this.props.onClick({
            event: event,
            height: height,
            division: hoveredDivision
        });
    }
    onClick(event) {
        // This event handler might be unnecessary
        if (this.props.allowEditing) return this.onEditInterval(event);
        const height = this.heightForEvent(event);
        return this.props.onClick({
            height: height
        });
    }
    renderCursorLine() {
        let { height: height, hoveredDivision: hoveredDivision } = this.state;
        const { scaleClamped: scaleClamped } = this.context;
        // Show the height we have selected if we are not hovering
        const { selectedHeight: selectedHeight } = this.props;
        if (height == null) height = selectedHeight;
        if (height == null) return;
        const style = {
            top: scaleClamped(height),
            height: 0,
            border: "0.5px solid black",
            width: this.context.widthForDivision(hoveredDivision),
            position: "absolute",
            pointerEvents: "none"
        };
        return (0, $4bJ9d.default)("div.cursor", {
            style: style
        }, [
            (0, $4bJ9d.default)("div.cursor-position", {
                style: {
                    pointerEvents: "none",
                    fontWeight: "bold",
                    fontSize: "12px",
                    left: "2px",
                    top: "-14px",
                    position: "absolute",
                    color: "black"
                }
            }, [
                $93d6aa7da8db25fe$var$fmt2(height)
            ])
        ]);
    }
    renderHoveredBox() {
        if (this.state.hoveredDivision == null) return null;
        const { popoverIsOpen: popoverIsOpen, hoveredDivision: division } = this.state;
        const width = this.context.widthForDivision(division);
        const { color: color } = this.props;
        const background = (0, $iVDzM$chromajs)(color).alpha(0.3).css();
        return (0, $4bJ9d.default)($93d6aa7da8db25fe$var$OverlayBox, {
            division: division,
            className: "hovered-box",
            background: background
        }, [
            (0, $4bJ9d.default).if(this.props.renderEditorPopup != null)((0, $iVDzM$Popover), {
                isOpen: popoverIsOpen && division != null,
                //style: { display: "block", width },
                position: (0, $iVDzM$Position).LEFT
            }, [
                (0, $4bJ9d.default)("div", {
                    style: {
                        width: width,
                        height: 30,
                        transform: "translate(0,-30)"
                    }
                }),
                (0, $4bJ9d.default)("div.editor-popover-contents", {
                    style: {
                        width: this.props.popoverWidth,
                        padding: "10px"
                    }
                }, [
                    (0, $4bJ9d.default)($93d6aa7da8db25fe$var$PopoverEditorTitle, {
                        interval: division
                    }, [
                        (0, $4bJ9d.default)((0, $iVDzM$Button), {
                            icon: "cross",
                            minimal: true,
                            intent: (0, $iVDzM$Intent).WARNING,
                            onClick: this.closePopover.bind(this)
                        })
                    ]),
                    this.props.renderEditorPopup(division)
                ])
            ])
        ]);
    }
    closePopover() {
        return this.setState({
            popoverIsOpen: false
        });
    }
    render() {
        let { divisions: divisions, pixelHeight: pixelHeight, width: width } = this.context;
        const { popoverIsOpen: popoverIsOpen, hoveredDivision: division } = this.state;
        const { left: left, top: top, color: color } = this.props;
        if (width == null) ({ width: width } = this.props);
        return (0, $4bJ9d.default)((0, $iVDzM$uibox), {
            className: "edit-overlay",
            width: width,
            height: pixelHeight,
            ref: this.elementRef,
            style: {
                left: left,
                top: top,
                position: "absolute",
                zIndex: 18,
                pointerEvents: "all",
                cursor: "pointer"
            },
            onClick: this.onEditInterval,
            onMouseEnter: this.onHoverInterval,
            onMouseMove: this.onHoverInterval,
            onMouseLeave: ()=>{
                if (popoverIsOpen) return;
                this.setState({
                    height: null
                });
                return this.timeout = setTimeout(this.removeHoverBox, 1000);
            }
        }, [
            this.renderHoveredBox(),
            (0, $4bJ9d.default)($93d6aa7da8db25fe$var$EditingBox, {
                division: this.props.editingInterval,
                color: color
            }),
            this.renderCursorLine()
        ]);
    }
}


export {$93d6aa7da8db25fe$export$76fcb8530f09ae2e as DivisionEditOverlay};
//# sourceMappingURL=column-components.7c336aaf.js.map
